import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

declare var $: any;

@Injectable()
export class RestCallerService {

  // inactivityTimeoutPeriodMillis: number = 1000*60*30;   // half hour
  inactivityTimeoutPeriodMillis: number = 1000*60*60;   // one hour
  logoutTimer: any;

  constructor(private http: Http, private router: Router) {
  }

  checkAuthExpiry() {
    if (this.logoutTimer)
      clearTimeout(this.logoutTimer);
    this.logoutTimer = setTimeout(() => {
      this.logout();
    }, this.inactivityTimeoutPeriodMillis);
    let expiry: Number = Number(sessionStorage.getItem('authTokenExpiry'));
    if (expiry == null || Number.isNaN(expiry.valueOf()) || expiry <= 0)
      this.logout();
    if (expiry <= (Date.now()+(this.inactivityTimeoutPeriodMillis)))
      this.doGetFreshAuthTokenSynchronously();
  }

  doGetFreshAuthTokenSynchronously() {
    $.ajax({
      type: 'POST',
      url: environment.restApiPrefix + '/relogin',
      contentType: 'application/json',
      data: '{"authToken":"'+sessionStorage.getItem('authToken')+'"}',
      dataType: 'json',
      async: false,
      success: function(responseData) {
        sessionStorage.setItem('authToken', responseData.authToken);
        sessionStorage.setItem('authTokenExpiry', responseData.authTokenExpiry);
      }
    });
  }

  getHeaders() : Headers {
    this.checkAuthExpiry();
    let headers: Headers = new Headers();
    headers.append('X-Auth-Token', sessionStorage.getItem('authToken'));
    headers.append('Cache-control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    return headers;
  }

  //#region Account Related APIs

  authenticateUser(UserName: string, Password: string) {
    // dont check expiry on call that gets the expiry value itself
    return this.http.post(environment.restApiPrefix + '/login', { username: UserName, password: Password });
  }

  updatePassword(UserName: string, Password: string) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/update-password',
      { username: UserName, password: Password },
      { headers: headers, withCredentials: true });
  }

  forgotPassword(UserName: string) {
    // let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/regenerate-password',
      { username: UserName },
      // { headers: headers, withCredentials: true });
      { withCredentials: true });
  }

  logout() {
    sessionStorage.clear();
    $(".modal-backdrop").remove(); // remove modal backdrop if user had a modal open.
    $(".swal-overlay").remove(); // remove swal modal backdrop if user navigates browser with a modal open.
    this.router.navigate(['login']);
  }


  getUserDetails() {
    if (sessionStorage.getItem('currentUser')) {
      return JSON.parse(sessionStorage.getItem('currentUser'));
    };
  }

  addInternalUser(userName: string) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/add-internal-user',
      { username: userName },
      { headers: headers, withCredentials: true });
  }

  addExternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/add-external-user',
      o, { headers: headers, withCredentials: true });
  }

  updateInternalUser(userName: string) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/update-internal-user',
      { username: userName },
      { headers: headers, withCredentials: true });
  }

  updateExternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/update-external-user',
      o, { headers: headers, withCredentials: true });
  }

  getAssociatedClientsForExternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/get-associated-clients',
      o, { headers: headers, withCredentials: true });
  }

  setAssociatedClientsForExternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/set-associated-clients',
      o, { headers: headers, withCredentials: true });
  }

  getClientPortalSsoLoginUrl(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/get-client-portal-sso-login-url',
      o, { headers: headers, withCredentials: true });
  }

  deactivateUser(userName: string) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/deactivate-user',
      { username: userName },
      { headers: headers, withCredentials: true });
  }

  reactivateUser(userName: string) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/user-management/activate-user',
      { username: userName },
      { headers: headers, withCredentials: true });
  }

  getUserList() {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/user-management/get-user-list', { headers: headers, withCredentials: true });
  }

  //#endregion;


  //#region Client APIs

  getListofClientForInternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/clients/search', o, { headers: headers, withCredentials: true });
  }

  getListofClientForExternalUser(o: object) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients', { headers: headers, withCredentials: true });
  }

  getClientById(clientId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients/' + clientId, { headers: headers, withCredentials: true });
  }

  getClientControlWorkbookInfo(clientId: number, state: string) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients/get-control-workbook-info/' + clientId + '/' + state, { headers: headers, withCredentials: true });
  }

  getClientControlWorkbookInfoV2(clientId: number, state: string) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients/get-control-workbook-info-v2/' + clientId + '/' + state, { headers: headers, withCredentials: true });
  }

  addClient(payerId: string) {
    const headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/clients', { payerId: payerId }, {headers: headers, withCredentials: true});
  }

  activateOrDeactivateClient(o: object) {
    const headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/clients/' + o['id'], o, {headers: headers, withCredentials: true});
  }

  updateClientById(o: object) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/clients/' + o['id'], o, { headers: headers, withCredentials: true });
  }

  getClientPayerIdDetails(payerId: string) {
    const headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients/by-payer-id/' + payerId, {headers: headers, withCredentials: true});
  }

  getCalculationApiCountForClient(clientId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/clients/calculation-api-count/' + clientId, { headers: headers, withCredentials: true });
  }

  updateCalculationApiCountForClient(clientId: number) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/clients/calculation-api-count/' + clientId, null, { headers: headers, withCredentials: true });
  }

  //#endregion


  //#region Employee APIs

  getEmployeeById(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/employees/' + employeeId, { headers: headers, withCredentials: true });
  }

  getEmployeesByClientId(clientId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/employees/client/' + clientId, { headers: headers, withCredentials: true });
  }

  getListofEmployees(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/employees/get-a-list-of-employees', o, { headers: headers, withCredentials: true });
  }

  createNewEmployee(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/employees', o, { headers: headers, withCredentials: true });
  }

  updateEmployeeById(o: object) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/employees/' + o['id'], o, { headers: headers, withCredentials: true });
  }

  deleteEmployeeById(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.delete(environment.restApiPrefix + '/employees/' + employeeId, { headers: headers, withCredentials: true });
  }

  submitCurrentQuarter(employeeid: number, clientId: number) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/employees/submit/' + employeeid, {"id": employeeid, "clientId": clientId }, { headers: headers, withCredentials: true });
  }

  exportCurrentQuarter(employeeid: number, clientId: number) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/employees/export/' + employeeid, {"id": employeeid, "clientId": clientId }, { headers: headers, withCredentials: true });
  }

  calculationEngineForEmployee(o: object) {
    let headers = this.getHeaders();
    headers.append("Content-type", "application/json");
    return this.http.post(environment.restApiPrefix + '/employees/calculation-engine', o, { headers: headers, withCredentials: true });
  }

  sendCalculationEmailForEmployee(o: object) {
    let headers = this.getHeaders();
    headers.append("Content-type", "application/json");
    return this.http.post(environment.restApiPrefix + '/employees/calculation-engine-email', o, { headers: headers, withCredentials: true });
  }

  //#endregion

  //#region Payroll V2 APIs

  getPayrollV2Logs(fromDate: string, toDate: string) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/get-payroll-log/' +
      fromDate +'/'+ toDate, { headers: headers, withCredentials: true });
  }

  getEmployeePayrollV2DataForLastQuarter(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/last-quarter/employee/' +
      employeeId, { headers: headers, withCredentials: true });
  }

  getEmployeeListPayrollV2DataForCurrentQuarter(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/current-quarter/employee-list', o, { headers: headers, withCredentials: true });
  }

  getEmployeeListPayrollV2ExceptionDataForCurrentQuarter(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/current-quarter-exceptions/employee-list', o, { headers: headers, withCredentials: true });
  }

  getEmployeePayrollV2DataForCurrentQuarter(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/current-quarter/employee/' +
      employeeId, { headers: headers, withCredentials: true });
  }

  getEmployeePayrollV2ExceptionsDataForCurrentQuarter(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/current-quarter-exceptions/employee/' +
      employeeId, { headers: headers, withCredentials: true });
  }

  getEmployeePayrollV2DataYtdValues(employeeId: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/ytd-values/employee/' +
      employeeId, { headers: headers, withCredentials: true });
  }



  createNewPayrollV2(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2', o, { headers: headers, withCredentials: true });
  }

  updatePayrollV2(o: object) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/payrolls-v2/' + o['id'], o, { headers: headers, withCredentials: true });
  }

  deletePayrollV2(id: number) {
    let headers = this.getHeaders();
    return this.http.delete(environment.restApiPrefix + '/payrolls-v2/' + id, { headers: headers, withCredentials: true });
  }

  rollOverLastQuarterPayrollV2(employeeid: number) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/roll-over-last-quarter/employee/' + employeeid, { }, { headers: headers, withCredentials: true });
  }

  clonePayrollV2Record(employeeid: number) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/roll-over-last-record/employee/' + employeeid, { }, { headers: headers, withCredentials: true });
  }

  clearCurrentQuarterPayrollV2Records(employeeid: number) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/clear-current-quarter/employee/' + employeeid, { }, { headers: headers, withCredentials: true });
  }

  getClientUdfLookup(employeeid: number) {
    const headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/get-client-udf-lookup/' + employeeid, { headers: headers, withCredentials: true });
  }

  getClientLocalTaxLookup(employeeid: number) {
    const headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/payrolls-v2/get-client-local-tax-lookup/' + employeeid,
      { headers: headers, withCredentials: true });
  }

  exportPayroll(o: Object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/payrolls-v2/export', o, { headers: headers, withCredentials: true });
  }

  //#endregion

  //LogBook APIs

  getLogBookForYearAndQuarter(year: number, quarter: number) {
    let headers = this.getHeaders();
    return this.http.get(environment.restApiPrefix + '/logbooks/' +
      year +'/'+ quarter, { headers: headers, withCredentials: true });
  }

  createLogBook(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/logbooks', o, { headers: headers, withCredentials: true });
  }

  updateLogBook(id: number, o: object) {
    let headers = this.getHeaders();
    return this.http.put(environment.restApiPrefix + '/logbooks/' + id, o, { headers: headers, withCredentials: true });
  }

  deleteLogBook(id: number) {
    let headers = this.getHeaders();
    return this.http.delete(environment.restApiPrefix + '/logbooks/' + id, { headers: headers, withCredentials: true });
  }

  //#endregion

  //Reports APIs

  getReport(o: object) {
    let headers = this.getHeaders();
    return this.http.post(environment.restApiPrefix + '/reports', o, { headers: headers, withCredentials: true });
  }

   //#endregion

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  downloadBlob(blob, fileName) {
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // for IE
       window.navigator.msSaveBlob(blob, fileName);
      return;
    }
    // for Chrome
    var url= window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/services/rest-caller.service.ts